import { useMediaQuery } from 'react-responsive';

export function useResponsive(): {
  isLgWidth: boolean;
  isMdWidth: boolean;
  isSmWidth: boolean;
  isXsWidth: boolean;
} {
  const isLgWidth = useMediaQuery({
    query: '(min-width: 961px)'
  });
  const isMdWidth = useMediaQuery({
    query: '(max-width: 960px)'
  });
  const isSmWidth = useMediaQuery({
    query: '(max-width: 769px)'
  });
  const isXsWidth = useMediaQuery({
    query: '(max-width: 481px)'
  });

  return {
    isLgWidth,
    isMdWidth,
    isSmWidth,
    isXsWidth
  };
}
